module.exports = __webpack_public_path__ + "img/hexRuin.2ef9fa85.png";